import { makeStyles } from '@material-ui/core';
var multiChoiceGroupStyles = makeStyles(function (theme) { return ({
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    chip: {
        margin: 2,
    },
}); });
export default multiChoiceGroupStyles;
//# sourceMappingURL=styles.js.map